// js/components/cart-manager.js

import { globalStore } from '../store/index.js';

// Função auxiliar para salvar o carrinho e notificar a aplicação
function saveCartAndNotify(cart) {
    globalStore.setCart(cart);
}

const CartManager = {
    // Pega o carrinho do store
    getCart() {
        return globalStore.state.cart;
    },

    // Adiciona um item ao carrinho
    addItem(productId, quantity = 1) {
        const cart = this.getCart();
        const existingItem = cart.find(item => item.id === productId);

        if (existingItem) {
            existingItem.quantity += quantity;
        } else {
            cart.push({ id: productId, quantity });
        }
        saveCartAndNotify(cart);
    },

    // Remove um item do carrinho
    removeItem(productId) {
        let cart = this.getCart();
        cart = cart.filter(item => item.id !== productId);
        saveCartAndNotify(cart);
    },

    // Atualiza a quantidade de um item específico
    updateQuantity(productId, quantity) {
        const cart = this.getCart();
        const itemToUpdate = cart.find(item => item.id === productId);

        if (itemToUpdate) {
            if (quantity > 0) {
                itemToUpdate.quantity = quantity;
            } else {
                // Se a quantidade for 0 ou menos, remove o item
                return this.removeItem(productId);
            }
        }
        saveCartAndNotify(cart);
    },

    // Limpa o carrinho completamente
    clearCart() {
        saveCartAndNotify([]);
    },

    // Retorna o número total de itens no carrinho (soma das quantidades)
    getTotalItems() {
        return this.getCart().reduce((total, item) => total + item.quantity, 0);
    }
};

export default CartManager;